import React, { useEffect, useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import SendForm from "./SendForm";
import { Modal } from "./SendDocModal";
import { formReady, loadMessageDraft, sendForm } from "../lib/docSend";

export default function MessageModal({ dossierId, onClose, onSent }) {
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = (tid, role) => loadMessageDraft(dossierId, tid, role).then(setForm).catch((e) => { toast.error(e?.response?.data?.detail || "Chargement impossible"); onClose(); });
  useEffect(() => { load(); }, [dossierId]); // eslint-disable-line react-hooks/exhaustive-deps
  const send = async () => {
    const win = form.channels.whatsapp ? window.open("", "_blank") : null;
    setBusy(true);
    try {
      await sendForm(dossierId, form, win);
      toast.success(`Message envoyé${form.channels.whatsapp ? " — WhatsApp ouvert" : ""}`);
      onSent?.();
      onClose();
    } catch (e) { win?.close(); toast.error(e?.response?.data?.detail || "Envoi impossible"); }
    finally { setBusy(false); }
  };
  return (
    <Modal title="Écrire un message" onClose={onClose} testid="message-modal"
      footer={<>
        <button onClick={onClose} className="btn-secondary text-sm">Annuler</button>
        <button onClick={send} disabled={busy || !formReady(form)} className="btn-primary text-sm" data-testid="message-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer</button>
      </>}>
      {!form ? <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div>
        : <SendForm dossierId={dossierId} form={form} setForm={setForm} prefix="message" onRole={(r) => load(form.template_id, r)} onTemplate={(tid) => load(tid)} />}
    </Modal>
  );
}
